import { useState } from "react";
import useFetch from "../../../../hooks/useFetch";
import { sortByKey } from "../../utils/string";

export default function useCognitiveReport() {
  const { request, loading } = useFetch();
  const [data, setData] = useState([]);

  const fetchData = async (url) => {
    const res = await request(url);
    if (res?.data) {
      const mapped = res.data.questionsCognitiveStats.map((item) => ({
        Subject: item._id.name,
        Knowledge: item.knowledge,
        Analysis: item.analysis,
        Understanding: item.understanding,
        Application: item.application,
      })).filter(item => item?.Knowledge + item?.Analysis + item?.Understanding + item?.Application > 0);
      setData(sortByKey(mapped,"Subject"));
    }
  };

  return { data, loading, fetchData };
}